import React, { useState } from "react";
import axios from "axios";
import { Box, Card, Container, Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { API_BASE_URL } from "../../constants/apiConstants";
import { useNavigate, useParams } from "react-router-dom";

const Activation = () => {
  const navigate = useNavigate();
  const { token } = useParams();

  const [loading, setLoading] = useState(false);

  const [validatedAccount, setValidatedAccount] = useState(false);
  const [messageByStatus, setMessageByStatus] = useState(
    "Haga click en el botón para validar su cuenta"
  );
  const [errorMessage, setErrorMessage] = useState("");

  const handleActivation = async () => {
    setLoading(true);
    const activation = await putActivaUsuario(token);
    if (activation && activation.status === "Ok") {
      setValidatedAccount(!validatedAccount);
      setMessageByStatus(activation.successMessage);
    } else {
      setErrorMessage(activation.errors.join());
    }
    setLoading(false);
  };

  const putActivaUsuario = async (token) => {
    try {
      const url = `${API_BASE_URL}Medicos/ActivaUsuario`;
      const response = await axios.post(url, { token });
      return response.data;
    } catch (error) {
      setErrorMessage(`${error.join()}`);
    }
  };

  const handleGoToLogin = () => {
    navigate("/");
  };

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        marginTop: 20,
      }}
    >
      <Container maxWidth="sm">
        <Card sx={{ padding: "20px" }}>
          <Box sx={{ my: 1 }}>
            <Typography
              color="textPrimary"
              align="center"
              variant="h4"
            >
              Validación de Usuario
            </Typography>
          </Box>
          <Box
            sx={{
              pb: 1,
              pt: 1,
            }}
          >
            <Typography
              align="center"
              color="textSecondary"
              variant="body1"
            >
              {!errorMessage && messageByStatus}
            </Typography>
          </Box>
          {errorMessage && (
            <Typography
              sx={{
                fontSize: "1rem",
                fontWeight: "400",
                textAlign: "center",
                color: "red",
              }}
            >
              {errorMessage}
            </Typography>
          )}
          {!errorMessage && (
            <Box sx={{ py: 2 }}>
              <LoadingButton
                loading={loading}
                color="primary"
                fullWidth
                size="large"
                type="button"
                onClick={validatedAccount ? handleGoToLogin : handleActivation}
                variant="contained"
              >
                {validatedAccount ? "Ir al login" : "Validar cuenta"}
              </LoadingButton>
            </Box>
          )}
        </Card>
      </Container>
    </Box>
  );
};

export default Activation;
